import { FC } from "react";
import { Navigate } from "react-router-dom";

const PostAuthorization: FC = () => {
  const authRedirect = localStorage.getItem("auth-redirect");

  let redirect: { pathname: string; search: string } | null = null;
  try {
    if (authRedirect) redirect = JSON.parse(authRedirect);
  } catch {
    /* empty */
  }

  if (!redirect || redirect.pathname === "/") {
    // show dashboard by default
    return <Navigate replace to="/dashboard" />;
  } else {
    return <Navigate replace to={`${redirect.pathname}${redirect.search}`} />;
  }
};

export default PostAuthorization;
